<mat-menu #btnMenuStatus="matMenu" style="max-width: auto !important;">
    <div style="padding: 0px 8px;">
      <button 
        id="buttonmat" 
        *ngFor="let option of options"  
        [ngClass]="option.icon ? 'gts-btn-select-option-primary with-icon' : 'gts-btn-select-option-primary'"
        [disabled]="option.disabled"
        matRipple 
        style="width: 100%; margin-bottom: 8px;" 
        (click)="executeAction(option)">
        <span 
          class="material-icons" 
          style="padding-right: 8px; font-size: 18px;" 
          [style.color]="option.iconColor || 'var(--ha-primary-color)'" 
          *ngIf="option.icon">{{ option.icon }}</span>
        <span class="gts-btn-text">{{ option.label }}</span>
      </button>
    </div>
  </mat-menu>
  
  <button 
    *ngIf="!outline" 
    class="gts-btn-select-primary" 
    matRipple 
    [matMenuTriggerFor]="btnMenuStatus" 
    [disabled]="disabled" 
    style="max-width: 310px">
    <div style="display: flex; align-items: center;">
      <span 
        class="material-icons" 
        style="padding-right: 8px; font-size: 18px;" 
        [style.color]="'var(--ha-primary-color)'" 
        *ngIf="icon">{{ icon }}</span>
      <span class="gts-btn-text">{{ label }}</span>
      <span class="gts-btn-select-icon">expand_more</span>
    </div>
  </button>
  
  <mat-menu #btnMenuStatusWithIcon="matMenu" style="max-width: auto !important;">
    <div style="padding: 0px 8px">
      <button 
        *ngFor="let option of optionsIcons"
        class="gts-btn-select-option-primary-outline"
        [disabled]="option.disabled"
        matRipple 
        style="width: 100%; margin-bottom: 8px;" 
        (click)="executeAction(option)">
        <span 
          class="material-icons" 
          style="padding-right: 8px; font-size: 18px;" 
          [style.color]="option.iconColor || 'inherit'" 
          *ngIf="option.icon">{{ option.icon }}</span>
        <span class="gts-btn-text">{{ option.label }}</span>
      </button>
    </div>
  </mat-menu>
  
  <button 
    *ngIf="outline" 
    class="gts-btn-select-primary-outline" 
    matRipple 
    [matMenuTriggerFor]="btnMenuStatusWithIcon" 
    [disabled]="disabled">
    <div style="display: flex; align-items: center;">
      <span 
        class="material-icons" 
        style="padding-right: 8px; font-size: 18px;" 
        [style.color]="colorIcon || 'var(--ha-primary-color)'" 
        *ngIf="icon">{{ icon }}</span>
      <span class="gts-btn-text">{{ label }}</span>
      <span class="gts-btn-select-icon">expand_more</span>
    </div>
  </button>